/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crisp_Pale_Finch_SingInputs */

const en_crisp_pale_finch_sing = /** @type {(inputs: Crisp_Pale_Finch_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open requests could not be loaded`)
};

const de_crisp_pale_finch_sing = /** @type {(inputs: Crisp_Pale_Finch_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offene Anfragen konnten nicht geladen werden`)
};

/**
* | output |
* | --- |
* | "Open requests could not be loaded" |
*
* @param {Crisp_Pale_Finch_SingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const crisp_pale_finch_sing = /** @type {((inputs?: Crisp_Pale_Finch_SingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crisp_Pale_Finch_SingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crisp_pale_finch_sing(inputs)
	return de_crisp_pale_finch_sing(inputs)
});